<div class="animate__animated animate__fadeInRight">
  <br />

  <div class="col">
    <mat-card class="mat_card_general p-5">
      <h1>Módulo de Entrega de Equipos</h1>
    </mat-card>
  </div>

  <br />

  <div *ngIf="conflictos.length > 0" class="alert alert-warning">
    <strong>{{ conflictos.length }} equipo(s) con conflicto detectado</strong> — quedaron activos
    en más de un trabajador a la vez (probablemente se ignoró un aviso de serie duplicada).
    <ul class="mb-0">
      <li *ngFor="let c of conflictos">
        {{ c.EquipoTecnologico?.marca }} {{ c.EquipoTecnologico?.modelo }} (S/N: {{ c.EquipoTecnologico?.numeroSerie }})
        — activo en:
        <span *ngFor="let t of c.trabajadoresActivos; let last = last">
          {{ t.TrabajadorAsignado?.nombres }} {{ t.TrabajadorAsignado?.apellidos }}{{ last ? '' : ', ' }}
        </span>
      </li>
    </ul>
  </div>

  <app-generar-entrega-equipos
    (linkGenerado_evento)="actualizarTabla($event)"
  ></app-generar-entrega-equipos>

  <br />

  <mat-card class="mat-elevation-z0 mat_card_general_content">
    <mat-tab-group>
      <mat-tab label="Equipos asignados">
        <br />
        <app-buscar-historial-trabajador></app-buscar-historial-trabajador>
        <hr />
        <app-listar-asignados-entrega-equipos
          [asignados_List]="asignados"
          (actualizado)="actualizarTabla($event)"
        ></app-listar-asignados-entrega-equipos>
      </mat-tab>
      <mat-tab label="Links pendientes / vencidos">
        <br />
        <app-listar-pendientes-entrega-equipos
          [pendientes_List]="pendientes"
          (actualizado)="actualizarTabla($event)"
        ></app-listar-pendientes-entrega-equipos>
      </mat-tab>
    </mat-tab-group>
  </mat-card>
  <hr />
</div>
